import React, {useCallback, useState} from 'react';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';

import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';

import { withFirebase } from '../../contexts/Firebase';
import { AuthUserContext } from '../../contexts/Session';
import logoOuvidoria from '../../assets/logos/logoApp.svg';
import { ReactComponent as EmailIcon } from '../../assets/Icons/email-login.svg';

import './styles.css';

const ForgotPasswordPage = () => (
    <div id="sign-in-page">
        <ForgotPasswordForm />
    </div>
)

function SignInFormBase(props){

    const[email, setEmail] = useState('');
    
    const[error, setError] = useState(false);
    const[errorMsg, setErrorMsg] = useState('');
    
    const[clicked, setClicked] = useState(false);
    const[loginError, setLoginError] = useState(false);

    const handleReturn = useCallback(() => {
        props.history.push('/login');
    }, [props.history]);

    function userAlreadyLogged(){
        try {
            props.firebase.auth.currentUser.getIdTokenResult()
                .then((idTokenResult) => {
                    localStorage.setItem('@Z52InSD4dnfjUDeVSEB0Byy',idTokenResult.token)
                    localStorage.setItem('VSEB0Byy',idTokenResult.claims.user_id)
                    console.log(idTokenResult);
                    if(!!idTokenResult.claims.admin){
                        localStorage.setItem('adm', true)
                        props.history.push('/list-profiles')
                        console.log('adm')

                    }else if(!!idTokenResult.claims.ouvidoria){
                        localStorage.setItem('adm', false)
                        props.history.push('/list-profiles')
                        console.log('ouvidoria')

                    }else if(!!!idTokenResult.claims.ouvidoria && !!!idTokenResult.claims.admin){
                        console.log('opaa')
                        props.firebase.doSignOut()
                        setClicked(false)
                        alert('Essa conta não tem acesso ao sistema')

                    }
                })

        } catch (error) {
            setLoginError(true)
        }
    }

    const onSubmit = async event => {
        setClicked(!clicked);
        props.firebase.sendPasswordRecover(email)
        .then( ( response) => {
            console.log('responseInRecvPage', response);
            if (response) {
                setClicked(false);
                alert('E-mail de recuperação enviado com sucesso.');
                handleReturn();
            }else{
                setClicked(false);
                alert('Erro na recuperação do E-mail.');
            }
        })
        .catch( (error) => {
            console.log(error, 'errorinRecvP');
            setClicked(false);
            setErrorMessage(error);
        })
        event.preventDefault();
    }

    function setErrorMessage(error){
        if (error.code === 'auth/user-disabled') {
            alert('Sua conta foi bloqueada, solicite o desbloqueio ao administrador');
        }
        if(email===''){
            setErrorMsg('Você deve inserir um usuário');
            setError(true);
            return
        }
        else{
            if(error.code === 'auth/invalid-email'){
                setErrorMsg('Email inválido');
                setError(true);
                return
            }
            if(error.code === 'auth/user-not-found'){
                setErrorMsg('Usuário não encontrado');
                setError(true);
                return
            }
        }

    }

    return (
        <AuthUserContext.Consumer>
        {
        authUser =>
            !authUser || loginError ? // !authUser || loginError? 
                <div className='container-background'>
                    <div className='container-login'>
                        <img src={logoOuvidoria} alt="ouvidoria" className='login-image'/>   
                        <form onSubmit={onSubmit}>
                            <div className='login-inputs'>
                                <TextField
                                    className='input-login' 
                                    id="input-email"
                                    label={error ? errorMsg :"Email"} 
                                    error={error}
                                    value={email}
                                    fullWidth
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <EmailIcon />
                                            </InputAdornment>
                                        ),
                                    }}
                                    onChange={event => {
                                        setEmail(event.target.value);
                                        setError(false);
                                    }} 
                                /> <br/> <br/>

                                <br/>
                            </div>
                            <button id ='submit-button'className='modal-header-button' disabled={clicked}>
                                {clicked ?
                                    <CircularProgress color='secondary' size={15} /> 
                                :
                                    <p className='modal-header-button-text'>RECUPERAR A SENHA</p>
                                }
                            </button>
                            <p className='text-login' onClick={handleReturn}>Voltar</p>
                            <br/><br/>
                        </form>

                    </div>
                </div>
                :userAlreadyLogged()

        }
        </AuthUserContext.Consumer>
    )
}

const ForgotPasswordForm = compose(
    withRouter,
    withFirebase,
)(SignInFormBase);

export default ForgotPasswordPage;

export { ForgotPasswordForm };